// extracted by mini-css-extract-plugin
export default {"heading":"LandscapeIndicatorExternalResourceAddTemplate_heading__01HF4","buttonLink":"LandscapeIndicatorExternalResourceAddTemplate_buttonLink__nwoMz"};